import './App.css';
import Logo from './Logo.png';
import Dictionary from './DictionaryFolder/Dictionary';

function App() {
  return (
    <div className="App">
      <div className='container'>
      <header className='container'>
      <img src={Logo} className="App-logo" alt="Logo"/>
      </header>
      <main>
        <Dictionary />
      </main>
      <small>
      <footer className='text-center'> <em>This project was coded by <a href="https://www.shecodes.io/graduates/161137-carolina-pereira-picetti" target="_blank" rel="noopener noreferrer">Carolina Picetti </a>
       and is open-sourced on <a href="https://github.com/CarolPicetti/dictionary-app" target="_blank" rel="noopener noreferrer">GitHub </a>
      and hosted on <a href="https://app.netlify.com/teams/carolpicetti/projects" target="_blank" rel="noopener noreferrer">Netlify</a>💙.</em>
      </footer> 
      </small>
    </div>
    </div>
  );
}

export default App;
